import { render, staticRenderFns } from "./CasualGroups.vue?vue&type=template&id=27f51658&"
import script from "./CasualGroups.vue?vue&type=script&lang=js&"
export * from "./CasualGroups.vue?vue&type=script&lang=js&"
import style0 from "./CasualGroups.vue?vue&type=style&index=0&id=27f51658&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports